import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Compass } from "lucide-react";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_atelier-tall/artifacts/55qqbuh3_ChatGPT%20Image%20May%2019%2C%202026%2C%2001_08_42%20PM.png";

export const HomeHero = () => (
  <section className="relative">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 pt-8 sm:pt-12 lg:pt-20 pb-16 sm:pb-20 grid grid-cols-12 gap-6 lg:gap-12 items-end">
      <div className="col-span-12 lg:col-span-6 fade-up">
        <div className="micro-label text-[#1a1814]/60 mb-6 sm:mb-8 inline-flex items-center gap-2">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#1a1814]" />
          Founders' Edition · Volume 01
        </div>
        <h1 className="font-display text-[52px] sm:text-[80px] lg:text-[120px] leading-[0.95] sm:leading-[0.92] tracking-[-0.02em] text-[#1a1814]">
          Designed
          <br />
          for the<br />
          <em className="italic font-light">tall.</em>
        </h1>
        <p className="text-[#1a1814]/70 max-w-md mt-6 sm:mt-8 text-sm sm:text-base leading-relaxed">
          Lounge and active wear engineered with longer inseams, extended hems and considered fabric — for women 5'9" and above.
        </p>
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-4 mt-8 sm:mt-10">
          <Link
            to="/shop"
            className="bg-[#1a1814] text-[#f0e9e1] px-8 sm:px-10 py-4 micro-label hover:bg-[#1a1814]/85 inline-flex items-center justify-center gap-3"
            data-testid="hero-shop-cta"
          >
            Shop the Collection <ArrowRight className="w-4 h-4" strokeWidth={1.25} />
          </Link>
          <Link
            to="/fit-quiz"
            className="border border-[#1a1814] text-[#1a1814] px-8 sm:px-10 py-4 micro-label hover:bg-[#1a1814]/5 inline-flex items-center justify-center gap-3"
            data-testid="hero-quiz-cta"
          >
            <Compass className="w-4 h-4" strokeWidth={1.25} /> Find your fit
          </Link>
        </div>
      </div>
      <div className="col-span-12 lg:col-span-6 fade-up fade-up-2">
        <div className="relative aspect-[4/5] overflow-hidden bg-[#efe6db]">
          <img src={HERO_IMG} alt="The Identity Atelier — Spring Lookbook" className="w-full h-full object-cover" style={{ objectPosition: "30% 55%" }} />
          <div className="absolute bottom-6 left-6 right-6 flex justify-between items-end">
            <div className="micro-label text-[#f0e9e1] mix-blend-difference">Spring Lookbook</div>
            <div className="font-serif italic text-[#f0e9e1] mix-blend-difference text-sm">Embroidered TIA</div>
          </div>
        </div>
      </div>
    </div>
    <div className="hairline max-w-[1440px] mx-auto" />
  </section>
);
